import api from '@/services/utils/apiInstance'

class RepairFileService {
  async create(data) {
    if (data instanceof FormData) {
      const response = await api.post('/distributor/repair-file/create', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } else {
      const response = await api.post('/distributor/repair-file/create', data)
      return response.data
    }
  }

  async update(repairFileId, data) {
    if (data instanceof FormData) {
      const response = await api.put('/distributor/repair-file/update/' + repairFileId, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } else {
      const response = await api.put('/distributor/repair-file/update/' + repairFileId, data)
      return response.data
    }
  }

  async updateRepairFileBreakdown(repairFileId, payload) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(payload))
    return this.update(repairFileId, formData)
  }

  async updateRepairFileGuarantee(repairFileId, payload) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(payload))
    return this.update(repairFileId, formData)
  }

  async get(repairFileBoomerangId) {
    const response = await api.get('/distributor/repair-file/' + repairFileBoomerangId)
    return response.data
  }

  async getCustomerServiceTransportPrefill(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/repair-file/' + repairFileBoomerangId + '/transport/customer-service-prefill'
    )
    return response.data
  }

  async acknowledgeKeyAccountWarning(repairFileBoomerangId) {
    const response = await api.put(
      '/distributor/repair-file/' + repairFileBoomerangId + '/key-account-warning/acknowledge'
    )
    return response.data
  }

  async close(data) {
    const response = await api.put('/distributor/repair-file/close', data)
    return response.data
  }

  async finalizationRepairFileUpdate(repairFileId, data) {
    const response = await api.post('/distributor/repair-file/finalization/' + repairFileId, data)
    return response.data
  }

  async askTransportByMailToRepairer(data) {
    const response = await api.post('/distributor/repair-file/transport-repairer', data)
    return response.data
  }

  async getPaginatedRepairFileList(sort, order, page, limit, signal = undefined) {
    const url =
      '/distributor/repair-file/list' +
      '?sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async getPaginatedRepairFileFullList(
    search,
    sort,
    order,
    page,
    limit,
    filters,
    signal = undefined
  ) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    const url =
      '/distributor/repair-file/full-list' +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit +
      '&filters=' +
      filters

    const response = await api.get(url, { signal })
    return response.data
  }

  async deleteRepairFile(data) {
    const response = await api.put('/distributor/repair-file/delete', data)
    return response.data
  }

  async getConfirmCost(repairFileId) {
    const response = await api.get(`/distributor/repair-file/${repairFileId}/confirm-cost`)
    return response.data
  }

  async updateConfirmCost(data) {
    const response = await api.put('/distributor/repair-file/confirm-cost', data)
    return response.data
  }

  async sendEstimatePackageEmailToClientWithFiles(data) {
    const response = await api.post('/distributor/repair-file/send-email-estimate-package', data)
    return response.data
  }

  async getPaginatedRepairFileCommentList(
    repair_file_boomerang_id,
    page,
    limit,
    signal = undefined
  ) {
    const url =
      '/distributor/repair-file-comment/' +
      repair_file_boomerang_id +
      '?page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async createRepairFileComment(data) {
    const response = await api.post('/distributor/repair-file-comment/create', data)
    return response.data
  }

  async getRepairFileCustomerRecoveryList(signal = undefined) {
    const response = await api.get('/distributor/repair-file/customer-recovery/all', { signal })
    return response.data
  }

  async getRepairFileNextActionList(signal = undefined) {
    const response = await api.get('/distributor/repair-file/next-actions/all', { signal })
    return response.data
  }

  async saveClientOptionChoice(optionSelected, token, expectedSelectionVersion) {
    const data = {
      optionSelected: optionSelected,
      emailToken: token,
      expected_selection_version: expectedSelectionVersion
    }

    const response = await api.post('/distributor/repair-file/estimate-package/choice', data, {
      publicCapability: true
    })
    return response.data
  }

  async getPackageChoiceContext(optionSelected, emailToken) {
    const response = await api.post(
      '/distributor/repair-file/estimate-package/choice/context',
      { optionSelected, emailToken },
      { publicCapability: true }
    )
    return response.data
  }

  async getRepairerChoiceContext(emailToken) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/email-selection-choice/context',
      { emailToken },
      { publicCapability: true }
    )
    return response.data
  }

  async saveLeaveReason(data) {
    const response = await api.post('/distributor/repair-file/leave-reasons', data)
    return response.data
  }

  async uploadAdditionalAttachmentFile(data) {
    const response = await api.put('/distributor/repair-file/upload-additional-attachment', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getTransporterDocument(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/repair-file/get-transporter-document/' + repairFileBoomerangId,
      {
        responseType: 'blob'
      }
    )
    return response.data
  }

  async getAdditionalAttachmentFileList(repairFileId) {
    const response = await api.get(
      '/distributor/repair-file/additional-attachment/list/' + repairFileId
    )
    return response.data
  }

  async createRepairFileRepairerEstimate(data) {
    const response = await api.post('/distributor/repair-file/repairer-estimate/create', data)
    return response.data
  }

  async updateRepairFileRepairerEstimate(data) {
    const response = await api.put('/distributor/repair-file/repairer-estimate/update', data)
    return response.data
  }

  async confirmationRepairFileRepairerEstimate(data) {
    const response = await api.put('/distributor/repair-file/repairer-estimate/confirmation', data)
    return response.data
  }

  async createRepairFileRepairerEstimateOption(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate-option/create',
      data
    )
    return response.data
  }

  async updateRepairFileRepairerEstimateOption(data) {
    const response = await api.put('/distributor/repair-file/repairer-estimate-option/update', data)
    return response.data
  }

  async deleteRepairFileRepairerEstimateOption(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate-option/delete',
      data
    )
    return response.data
  }

  async sendRepairFileRepairerEstimateToClient(data) {
    const response = await api.post('/distributor/repair-file/send-email-repairer-estimate', data)
    return response.data
  }

  async sendNewRepairFileRepairerEstimateToClient(data) {
    const response = await api.post(
      '/distributor/repair-file/send-new-email-repairer-estimate',
      data
    )
    return response.data
  }

  async saveRepairerEstimateOptionClientChoiceFromManualSelection(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/manual-selection-choice',
      data
    )
    return response.data
  }

  async saveRepairerEstimateOptionClientChoiceFromEmailSelection(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/email-selection-choice',
      data,
      { publicCapability: true }
    )
    return response.data
  }

  async updateRepairFileStatus(repairFileId, date, newStatus, declaration = {}) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    let data = {
      repairFileId: repairFileId,
      selectedDate: `${year}-${month}-${day}`,
      newStatus: newStatus,
      ...declaration
    }

    const response = await api.put('/distributor/repair-file/update-status', data)
    return response.data
  }

  async updateRepairFileStatusToReceiptAtStore(
    repairFileId,
    date,
    newStatus,
    clientTakeoverType,
    emailAddress,
    clientPhoneNotificationType,
    smsPhoneNumber,
    pickupPlace
  ) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    let data = {
      repairFileId: repairFileId,
      selectedDate: `${year}-${month}-${day}`,
      newStatus: newStatus,
      clientTakeoverType: clientTakeoverType,
      emailAddress: emailAddress,
      clientPhoneNotificationType: clientPhoneNotificationType,
      smsPhoneNumber: smsPhoneNumber,
      pickupPlace: pickupPlace != '' ? pickupPlace : null
    }

    const response = await api.put('/distributor/repair-file/update-status/receipt-at-store', data)
    return response.data
  }

  async updateRepairFileEmail(data) {
    const response = await api.put('/distributor/repair-file/update-email', data)
    return response.data
  }

  async sendGuaranteeExtensionBoomerangByEmail(send_to, repairFileBoomerangId) {
    let data = {
      email_address: send_to,
      repair_file_boomerang_id: repairFileBoomerangId
    }

    const response = await api.post(
      '/distributor/repair-file/send-guarantee-extension-boomerang-email',
      data
    )
    return response.data
  }

  async updateRepairFileDepartureAddress(departureTechnicalId, addressInfos) {
    const data = {
      technical_id: departureTechnicalId,
      departure_address_name: addressInfos.name,
      departure_address_number: addressInfos.number,
      departure_address_street: addressInfos.street,
      departure_address_complement_1: addressInfos.complementOne,
      departure_address_complement_2: addressInfos.complementTwo,
      departure_address_zip_code: addressInfos.zipCode,
      departure_address_city: addressInfos.city,
      departure_address_contact_name: addressInfos.contactName,
      departure_address_contact_email: addressInfos.contactEmail,
      departure_address_contact_phone_number: addressInfos.contactPhone
    }

    const response = await api.post('/distributor/repair-file/update-departure-address', data)
    return response.data
  }

  async addPurchaseOrderAttachment(data) {
    if (data instanceof FormData) {
      const response = await api.post(
        '/distributor/repair-file/repairer-estimate/add-purchase-order-attachment',
        data,
        {
          publicCapability: true,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response.data
    } else {
      const response = await api.post(
        '/distributor/repair-file/repairer-estimate/add-purchase-order-attachment',
        data,
        { publicCapability: true }
      )
      return response.data
    }
  }

  async backToStepper(repairFileId) {
    const response = await api.put('/distributor/repair-file/back-to-step-seven/' + repairFileId)
    return response.data
  }

  async addAttachmentFile(data) {
    const response = await api.post('/distributor/repair-file/add-attachment-file', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async addAttachmentFileFromPublicPage(data) {
    const response = await api.post('/distributor/repair-file/add-attachment-file/public', data, {
      publicCapability: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getAddAttachmentQRCodeToken(repairFileId, attachmentType) {
    const response = await api.get(
      '/distributor/repair-file/add-attachment/qr-code-token/' +
        repairFileId +
        '?attachmentType=' +
        attachmentType
    )
    return response.data
  }

  async validateRepairFileAddAttachmentQrCodeToken(token) {
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/distributor/repair-file/add-attachment/qr-code-token/validation',
      data,
      { publicCapability: true }
    )

    return response.data
  }

  async getUploadAdditionalAttachmentQRCodeToken(repairFileId) {
    const response = await api.get(
      '/distributor/repair-file/upload-additional-attachment/qr-code-token/' + repairFileId
    )
    return response.data
  }

  async validateRepairFileUploadAdditionalAttachmentQrCodeToken(token) {
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/distributor/repair-file/upload-additional-attachment/qr-code-token/validation',
      data,
      { publicCapability: true }
    )

    return response.data
  }

  async uploadAdditionalAttachmentFileFromPublicPage(data) {
    const response = await api.post(
      '/distributor/repair-file/upload-additional-attachment/public',
      data,
      {
        publicCapability: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async confirmAttachmentAddedByQrCode(repairFileId, qrCodeToken) {
    let data = {
      repairFileId: repairFileId,
      qrCodeToken: qrCodeToken
    }

    const response = await api.put(
      '/distributor/repair-file/add-attachment/confirm-attachment-added-by-qr-code',
      data
    )
    return response.data
  }

  async removeAttachmentFromRepairFile(repairFileId, attachmentType) {
    const data = {
      repairFileId: repairFileId,
      attachmentType: attachmentType
    }

    const response = await api.put('/distributor/repair-file/remove-attachment', data)
    return response.data
  }

  async saveLeaveReasonAndRecycle(data) {
    const response = await api.post('/distributor/repair-file/leave-reasons-and-recycle', data)
    return response.data
  }
}

export default new RepairFileService()
